import { useEffect, useState } from "react";
import axios from "axios";
import { Heart, Gift, ArrowRight } from "lucide-react";
import { churchInfo } from "../mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Donate() {
  const [info, setInfo] = useState(churchInfo);
  useEffect(() => {
    axios.get(`${API}/contact-info`).then(r => { if (r.data) setInfo({ ...churchInfo, ...r.data }); }).catch(() => {});
  }, []);
  return (
    <section className="relative py-24 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="rounded-2xl bg-[#f5f2ec] border border-[#e7dfd0] p-10 md:p-16 text-center relative overflow-hidden">
          <div className="absolute -top-16 -right-16 h-56 w-56 rounded-full bg-[#c8a36a]/15 blur-3xl" />
          <div className="absolute -bottom-16 -left-16 h-56 w-56 rounded-full bg-[#c8a36a]/10 blur-3xl" />

          <div className="relative">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-[#e7dfd0] text-[#0a2d38] text-xs uppercase tracking-[0.28em] font-bold mb-6">
              <Heart className="h-3.5 w-3.5 text-[#c8a36a]" /> Tithes & Offerings
            </div>
            <h2 className="text-4xl md:text-6xl font-bold text-[#0a2d38] leading-[1.05] tracking-tight">
              Sow into a <span className="text-[#c8a36a]">harvest</span><br />
              that lasts forever.
            </h2>
            <p className="mt-6 max-w-2xl mx-auto text-[#4a5b62] leading-relaxed text-lg">
              Every gift fuels worship, outreach, and the gospel rolling through Big Spring and beyond. Thank you for partnering with us.
            </p>
            <div className="mt-10 flex flex-wrap justify-center gap-4">
              <a href={info.donateUrl} target="_blank" rel="noreferrer"
                className="btn-gold rounded-full px-8 py-4 inline-flex items-center gap-2">
                <Gift className="h-4 w-4" /> Give Securely Now <ArrowRight className="h-4 w-4" />
              </a>
              <a href="#contact" className="rounded-full px-8 py-4 font-bold border border-[#0a2d38] text-[#0a2d38] hover:bg-[#0a2d38] hover:text-white transition-colors">
                Other Ways to Give
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
